var _symbol, _symbol2, _symbol3, _symbol4, _symbol5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2793 12.2071L5.2793 12.2071",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2793 17.2071L5.2793 12.2071L10.2793 7.20714",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83209 12L1.91574 11.5996L1.74081 12L1.91574 12.4004L2.83209 12ZM21.1679 12L22.0843 12.4004L22.2592 12L22.0843 11.5996L21.1679 12ZM3.74845 12.4004C5.13816 9.21965 8.31098 7 12 7V5C7.48775 5 3.61225 7.71673 1.91574 11.5996L3.74845 12.4004ZM12 7C15.689 7 18.8618 9.21966 20.2516 12.4004L22.0843 11.5996C20.3878 7.71674 16.5123 5 12 5V7ZM20.2516 11.5996C18.8618 14.7804 15.689 17 12 17V19C16.5123 19 20.3878 16.2833 22.0843 12.4004L20.2516 11.5996ZM12 17C8.31098 17 5.13816 14.7803 3.74845 11.5996L1.91574 12.4004C3.61225 16.2833 7.48775 19 12 19V17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8284 9.17157C14.1741 8.5172 13.313 8.10997 12.3921 8.01926C11.4711 7.92855 10.5472 8.15999 9.77772 8.67412C9.00826 9.18826 8.44087 9.95329 8.17224 10.8389C7.9036 11.7244 7.95034 12.6758 8.30448 13.5307C8.65863 14.3857 9.29826 15.0914 10.1144 15.5277C10.9306 15.9639 11.8727 16.1037 12.7804 15.9231C13.688 15.7426 14.505 15.2529 15.092 14.5376C15.6791 13.8222 16 12.9254 16 12H12L14.8284 9.17157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "eye_closed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59497 12.594C4.9623 14.6926 8.30069 16 12 16C15.6992 16 19.0376 14.6926 21.405 12.594",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13L1 14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13L23 14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15L4 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15L20 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16L8 19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16L16 19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V19.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM4 12C4 11.101 4.156 10.238 4.431 9.431L6 11L8 13V15L10 17L11 18V19.931C7.061 19.436 4 16.072 4 12ZM18.33 16.873C17.677 16.347 16.687 16 16 16V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13H10V10C10.5304 10 11.0391 9.78929 11.4142 9.41421C11.7893 9.03914 12 8.53043 12 8V7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5V4.589C17.928 5.778 20 8.65 20 12C19.9998 13.7647 19.4123 15.4791 18.33 16.873Z",
    fill: "black"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "login",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5L7 17C7 18.6569 8.34315 20 10 20L17 20C18.6569 20 20 18.6569 20 17L20 7C20 5.34315 18.6569 4 17 4L10 4C8.34315 4 7 5.34315 7 7L7 7.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16L16 12L12 8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12L2 12",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.ca2ba0e3c618c682d9141cb51c1e74ff.svg";
export { ForwardRef as ReactComponent };